import { Button, Flex, Tag, Typography, List, Tooltip, Card, Space } from 'antd';
import { useMedia } from '../../hooks/useMediaQuery';
import { teamRoles } from '../../common/constants/teamRoles';
import { teamRole } from '../../common/constants/teamRole';
import { spacing, buttonStyle } from '../../theming';

export default function TeamsCard({
    t,
    userMemberships,
    currentUser,
    handleLeaveClick,
    openDeleteModal,
    loading,
    classes,
}) {
    const { isSmallDevice, isExtraSmallDevice } = useMedia();

    return (
        <Card title={t('teams')} className={classes.card} style={{ width: '100%', maxWidth: '700px' }}>
            <List
                bordered={false}
                dataSource={userMemberships}
                renderItem={membership => {
                    const userRole = teamRoles.find(role => role.value === membership.role);

                    return (
                        <Tooltip
                            title={membership.isDeleted ? t('tooltip.archived') : ''}
                            open={membership.isDeleted ? undefined : false}
                            key={membership.id}
                        >
                            <List.Item
                                style={{
                                    padding: spacing[2],
                                    flexDirection: isSmallDevice ? 'column' : 'row',
                                    alignItems: 'center',
                                    gap: spacing[2],
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: isSmallDevice ? 'column' : 'row',
                                        alignItems: 'center',
                                        gap: spacing[2],
                                        flex: 1,
                                        width: '100%',
                                    }}
                                >
                                    <Typography.Text strong style={{ marginRight: spacing[2] }}>
                                        {membership.team.name}
                                    </Typography.Text>

                                    <Typography.Text style={{ textWrap: 'nowrap' }}>
                                        {`${membership.firstName || currentUser.firstName} ${membership.lastName || currentUser.lastName}`}
                                    </Typography.Text>

                                    <Tag
                                        style={{
                                            backgroundColor: userRole.backgroundColor,
                                            borderColor: userRole.borderColor,
                                            color: userRole.color,
                                            padding: `${spacing[0.5]}px ${spacing[3]}px`,
                                            fontWeight: 500,
                                            fontSize: 'inherit',
                                        }}
                                    >
                                        {userRole.label}
                                    </Tag>
                                </div>

                                <Space
                                    style={{
                                        marginTop: isSmallDevice ? spacing[2] : 0,
                                        width: isExtraSmallDevice ? '100%' : 'auto',
                                        justifyContent: isSmallDevice ? 'center' : 'flex-end',
                                    }}
                                >
                                    <Button
                                        type="primary"
                                        onClick={() => handleLeaveClick(membership.role, membership.team.id)}
                                        loading={loading.leave}
                                        disabled={membership.team.memberships.length === 1}
                                        style={{
                                            ...buttonStyle.small,
                                            width: isExtraSmallDevice ? '100%' : 'auto',
                                        }}
                                    >
                                        {t('button.leave')}
                                    </Button>

                                    <Button
                                        type="primary"
                                        danger
                                        onClick={() => openDeleteModal(membership.team.id)}
                                        loading={loading.delete}
                                        disabled={membership.role !== teamRole.OWNER}
                                        style={{
                                            ...buttonStyle.small,
                                            width: isExtraSmallDevice ? '100%' : 'auto',
                                        }}
                                    >
                                        {t('button.delete')}
                                    </Button>
                                </Space>
                            </List.Item>
                        </Tooltip>
                    );
                }}
            />
        </Card>
    );
}
